import { createFileRoute } from "@tanstack/react-router";

import { HubPage } from "@/components/hub-page";
import { VideoEmbed } from "@/components/video-embed";
import { homeFilms } from "@/data/home-films";

const TITLE = "Performance — Reel, Works & MAVRA | Luiza Jesus do Prado";
const DESC =
  "Performance art by Luiza Jesus do Prado: reel, ritual and live works, Butoh research and the MAVRA performance practice.";

export const Route = createFileRoute("/performance")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.luizajesusdoprado.com/performance" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: PerformancePage,
});

const reel = homeFilms.find((f) => f.id === "luiza-final-3") ?? homeFilms[0]!;

function PerformancePage() {
  return (
    <HubPage
      kicker="Live · Ritual · Body"
      title="Performance"
      intro="Ritual and durational performances where the body works as laboratory and archive — from Butoh research to the MAVRA practice."
      film={<VideoEmbed title="Performance reel" file={reel.src} poster={reel.poster} />}
      works={["butoh-caipira", "entities", "corpo-estranho", "the-painter", "fungi", "pudor", "devir", "animalia"]}
      sections={[
        {
          title: "MAVRA",
          links: [
            { label: "MAVRA — website", meta: "mavrayvyuna.com ↗", href: "https://www.mavrayvyuna.com" },
            { label: "MAVRA — Instagram", meta: "@mavrayvyuna ↗", href: "https://www.instagram.com/mavrayvyuna" },
            { label: "MAVRA Portfolio · EN", meta: "PDF ↗", href: "https://www.luizajesusdoprado.com/midia/Luiza-Jesus-do-Prado_MAVRA-Portfolio_EN.pdf" },
          ],
        },
        {
          title: "More",
          links: [
            { label: "All performance works", href: "/works" },
            { label: "Curriculum", href: "/cv" },
            { label: "Contact for performances", href: "/contact" },
          ],
        },
      ]}
    />
  );
}
